<template>
  <div class="container">
    <div >
      <router-link :to="{name: 'wfEmailTemplateEditor', params: {emailTemplateId: 'new'}}">Yeni Olustur</router-link>
    </div>
    <div v-bind:key="idx" v-for="(emailTemplate, idx) in emailTemplates" >
      <div>
        <router-link :to="{name: 'wfEmailTemplateEditor', params: {emailTemplateId: emailTemplate._id}}">{{ emailTemplate.name }}</router-link>
        <button type="button" v-on:click="deleteEmailWorkflowTemplate( emailTemplate._id )">Delete</button>
      </div>
    </div>
  </div>
</template>

<script>
 import axios from "axios";
 import {mapState} from 'vuex'
 const qs = require('qs')
 export default {
   name: 'wfEmailTemplates',
   data() {
     return {
       emailTemplates: []
     }
   },
   computed: {
     ...mapState([
       'baseUrl'
     ])
   },
   methods: {
     getEmailWorkflowTemplates() {
       axios({
         method:'POST',
         url:'/getEmailWorkflowTemplates',
         baseURL: this.baseUrl,
         withCredentials:true
       }).then((res)=>{
         return res
       }).then((res)=>{
         if(res.data.status.code==="0"){
           this.emailTemplates = res.data.content.email_workflow_templates;
         }else{
           this.$notify({
             group: 'foo',
             type: 'error',
             title: this.$ml.get('ERROR'),
             text: res.data.status.desc
           })
         }
       })
     },
     deleteEmailWorkflowTemplate(templateId) {
       axios({
         method:'POST',
         url:'/deleteEmailWorkflowTemplates',
         baseURL: this.baseUrl,
         data: {templateIds: [templateId]},
         withCredentials:true
       }).then((res)=>{
         return res
       }).then((res)=>{
         if(res.data.status.code==="0"){
           console.log("delete: OK")
           this.getEmailWorkflowTemplates()
         }else{
           this.$notify({
             group: 'foo',
             type: 'error',
             title: this.$ml.get('ERROR'),
             text: res.data.status.desc
           })
         }
       })
     },
   },
   mounted() {
     this.getEmailWorkflowTemplates()
   }
 }
</script>
